const LANGUAGE = {
    en: 'en',
    ja: 'ja',
    ko: 'ko',
    pt: 'pt',
    'zh-Hans': 'zh-Hans',
};

export default LANGUAGE;
